import iconBlack from './banzai_icon_rgb_black.svg';
import iconWhite from './banzai_icon_rgb_white.svg';
import iconRegular from './banzai_icon_rgb_banzai-blue.svg';
import logoBlack from './banzai_logo_rgb_black.svg';
import logoWhite from './banzai_logo_rgb_white.svg';
import logoRegular from './banzai_logo_rgb_banzai-blue.svg';
import styles from './banzai.module.css';
import { fontClasses } from './fonts/fonts';

const BanzaiTheme = {
  id: 'banzai',
  email: {
    address: 'no-reply@banzai.io',
    template: '%s@banzai.io',
    senderName: 'Banzai',
  },
  primaryColor: {
    hex: '#007be1',
    rgb: [0, 123, 225],
    hsl: [207, 100, 44],
  },
  publicImages: {
    iconBlack:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/banzai_icon_rgb_black.png',
    iconWhite:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/banzai_icon_rgb_white.png',
    iconRegular:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/banzai_icon_rgb_banzai-blue.png',
    logoBlack:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/banzai_logo_rgb_black.png',
    logoWhite:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/banzai_logo_rgb_white.png',
    logoRegular:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/banzai_logo_rgb_banzai-blue.png',
  },
  iconBlack,
  iconWhite,
  iconRegular,
  iconAlt: 'Banzai icon',
  logoBlack,
  logoWhite,
  logoRegular,
  logoAlt: 'Banzai logo',
  styles,
  productName: 'Banzai',
  fontClasses,
  login: {
    title: 'Login',
    subTitle: 'Get started now with the Banzai suite',
    quote: {
      text: 'We’re flipping the script on the old notion that marketing is best done behind a keyboard and instead are empowering and inspiring marketers to build relationships that impact their bottom line.',
      author: 'Joe Davy',
      role: 'CEO, Banzai International Inc.',
    },
  },
};

export default BanzaiTheme;
